import { render, staticRenderFns } from "./CustomizationPanel.vue?vue&type=template&id=29cea668&scoped=true&"
import script from "./CustomizationPanel.vue?vue&type=script&lang=js&"
export * from "./CustomizationPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationPanel.vue?vue&type=style&index=0&id=29cea668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cea668",
  null
  
)

export default component.exports